// YouTube links pasted in posts: watch?v=, youtu.be/, shorts/, embed/, live/ (also m., music. and
// youtube-nocookie.com), with an optional start time (t=1m30s, t=90, start=90)
const URL_RE = /https?:\/\/[^\s<>"{}|\\^`[\]]+/gi;
const ID_RE = /^[\w-]{11}$/;

function seconds(t) {
  if (!t) return 0;
  if (/^\d+$/.test(t)) return Number(t);
  const m = /^(?:(\d+)h)?(?:(\d+)m)?(?:(\d+)s)?$/.exec(t);
  return m ? (Number(m[1] || 0) * 3600) + (Number(m[2] || 0) * 60) + Number(m[3] || 0) : 0;
}

/** {id, start} for a YouTube video link, or null */
export function parseYouTube(url) {
  let u;
  try { u = new URL(url); } catch { return null; }
  const host = u.hostname.replace(/^(www|m|music)\./, '');
  let id = null;
  if (host === 'youtu.be') {
    id = u.pathname.split('/')[1];
  } else if (host === 'youtube.com' || host === 'youtube-nocookie.com') {
    const [, first, second] = u.pathname.split('/');
    id = first === 'watch' ? u.searchParams.get('v') : (['shorts', 'embed', 'live', 'v'].includes(first) ? second : null);
  }
  if (!id || !ID_RE.test(id)) return null;
  return { id, start: seconds(u.searchParams.get('t') || u.searchParams.get('start')) };
}

/** The first YouTube video among these links and texts, or null */
export function findYouTube(...texts) {
  for (const text of texts) {
    for (const url of String(text || '').match(URL_RE) || []) {
      const video = parseYouTube(url.replace(/[).,;:!?'"]+$/, ''));   // drop punctuation that ends the sentence
      if (video) return video;
    }
  }
  return null;
}
